
export const SETTINGS = {
    "button": {
        "background_color": "#ffffff",
        "text_color": "#005b97",
        "border_outline": 1,
        "corner_radius": 20,
        "border_color": "#005b97",
        "z_index": 0,
        "button_type": "static",
        "button_text": "Donate",
        "icon": "none",
        "button_shadow": false,
        "icon_position": "left"
    },
    "goal": {
        "progress_bar_color": "#0047AB",
        "progress_bar_type": "bar",
        "dark_mode": false,
        "size": 'medium',
        "border_outline": 1,
        "show_campaign": false,
        "show_description": true,
        "show_donations": true,
        "show_donate_btn": true,
        "btn_text": "Donate Now",
    }
}